import { useStore } from "../../hooks/useStore";

export function getEditOrder() {
    const editedOrder = useStore.getState().editOrder;
    if (editedOrder === null) {
        throw new Error("No order to edit");
    }
    return editedOrder;
}